import { render, staticRenderFns } from "./GenerateUserLetter.vue?vue&type=template&id=684866c8&"
import script from "./GenerateUserLetter.vue?vue&type=script&lang=js&"
export * from "./GenerateUserLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports